import SideSubMenu from 'components/SubMenu/SideSubMenu';
import Routes from 'constants/Routes';
import {
  HomeAnchorMappingAccessPolicy,
  includesRoles,
  RoutePlanFeedbackTriggerAccessPolicy,
  RoutePlanningGlobalSettingsAccessPolicy,
} from 'constants/Roles';
import useMe from 'contexts/authentication/useMe';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { arraySpreadIf } from 'utils/spreading';

/**
 * Inställningar → Ruttplanering. Själva fliken släpps fram av listan i GlobalSetting 116 (se
 * RequireRoutePlanningSettingsAccess); underflikarna behåller sina gamla rollkrav ovanpå, så
 * listan kan bara smalna av: hemankare kräver SuperAdmin eller HR och ruttprovet SuperAdmin,
 * precis som när de låg direkt under Inställningar.
 */
const RoutePlanningSettingsPage: FC = () => {
  const me = useMe();
  const canMapHomeAnchors = includesRoles(
    HomeAnchorMappingAccessPolicy.allow,
    me?.roles
  );
  const canTriggerFeedbackSample = includesRoles(
    RoutePlanFeedbackTriggerAccessPolicy.allow,
    me?.roles
  );
  const canEditSettings = includesRoles(
    RoutePlanningGlobalSettingsAccessPolicy.allow,
    me?.roles
  );

  return (
    <SideSubMenu
      title="Ruttplanering"
      items={[
        {
          label: 'Adresser utan position',
          path: Routes.settings.routePlanning.positions,
        },
        ...arraySpreadIf(canMapHomeAnchors, {
          label: 'Hemankare',
          path: Routes.settings.routePlanning.homeAnchorMapping,
        }),
        ...arraySpreadIf(canTriggerFeedbackSample, {
          label: 'Ruttprov',
          path: Routes.settings.routePlanning.feedbackSample,
        }),
        ...arraySpreadIf(canEditSettings, {
          label: 'Inställningar',
          path: Routes.settings.routePlanning.globalSettings,
        }),
      ]}
    >
      <Outlet />
    </SideSubMenu>
  );
};

export default RoutePlanningSettingsPage;
